var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-box"},[_c('div',{staticClass:"title"},[_vm._v("欢迎使用中交智运物流平台")]),_c('div',{staticClass:"intro"},[_vm._v("欢迎您注册成为本平台用户,注册前请仔细阅读本协议:")]),_c('AgreementContent',{attrs:{"resigister":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }